export function safeParseJSON(value: any) {
  try {
    if (typeof value === "string") {
      return JSON.parse(value);
    }
  } catch (err) {
    // Invalid JSON → return original
    return value;
  }
  return value;
}